import { Home, LayoutGrid, ClipboardList, Armchair, FileText, ChefHat, X, Wallet, Lock } from "lucide-react";

const TABS = [
  { id: "items", label: "Artigos", icon: LayoutGrid, color: "bg-amber-500 hover:bg-amber-400" },
  { id: "orders", label: "Pedidos em Curso", icon: ClipboardList, color: "bg-emerald-600 hover:bg-emerald-500" },
  { id: "tables", label: "Mesas", icon: Armchair, color: "bg-sky-600 hover:bg-sky-500" },
  { id: "invoices", label: "Faturas de Hoje", icon: FileText, color: "bg-violet-600 hover:bg-violet-500" },
];

export const POSTopBar = ({ view, setView, counts, user, cashSession, onHome, onKitchen, onCloseCash }) => (
  <header className="h-12 shrink-0 flex items-center gap-2 px-2 bg-[#121212] border-b border-white/5" data-testid="pos-topbar">
    <button
      onClick={onHome}
      className="w-9 h-9 rounded-md flex items-center justify-center text-emerald-400 hover:bg-white/5 transition-colors"
      data-testid="pos-home-btn"
      title="Voltar ao sistema"
    >
      <Home className="w-5 h-5" />
    </button>
    <nav className="flex items-center gap-1.5 overflow-x-auto">
      {TABS.map((t) => {
        const active = view === t.id;
        const count = counts[t.id];
        return (
          <button
            key={t.id}
            onClick={() => setView(t.id)}
            className={`h-8 px-3 rounded-md text-xs font-semibold text-white flex items-center gap-1.5 whitespace-nowrap transition-all ${t.color} ${
              active ? "ring-2 ring-white/80 shadow-lg" : "opacity-75 hover:opacity-100"
            }`}
            data-testid={`pos-tab-${t.id}`}
          >
            <t.icon className="w-3.5 h-3.5" />
            {t.label}
            {count > 0 && (
              <span className="ml-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-black/30 text-[10px] flex items-center justify-center" data-testid={`pos-tab-count-${t.id}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
      <button
        onClick={onKitchen}
        className="h-8 px-3 rounded-md text-xs font-semibold text-white bg-rose-600 hover:bg-rose-500 flex items-center gap-1.5 whitespace-nowrap opacity-75 hover:opacity-100 transition-all"
        data-testid="pos-tab-kitchen"
      >
        <ChefHat className="w-3.5 h-3.5" />
        Cozinha
      </button>
    </nav>
    <div className="ml-auto flex items-center gap-2">
      {cashSession !== undefined && (
        <a
          href="/cash"
          className={`h-7 px-2.5 rounded-full text-[11px] font-semibold flex items-center gap-1.5 border transition-colors ${
            cashSession ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30 hover:bg-emerald-500/25" : "bg-red-500/15 text-red-300 border-red-500/30"
          }`}
          data-testid="pos-cash-status"
          title={cashSession ? `Aberto por ${cashSession.opened_by_name || ""}` : "Caixa fechado"}
        >
          <Wallet className="w-3.5 h-3.5" />
          {cashSession
            ? `Caixa ${cashSession.offline ? "aberto OFFLINE" : "aberto"} · desde ${new Date(cashSession.opened_at).toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" })}`
            : "Caixa fechado"}
        </a>
      )}
      {cashSession && onCloseCash && (
        <button
          onClick={onCloseCash}
          className="h-7 px-2.5 rounded-full text-[11px] font-semibold flex items-center gap-1.5 border bg-red-500/15 text-red-300 border-red-500/30 hover:bg-red-500/25 transition-colors"
          data-testid="pos-close-cash-btn"
          title="Fechar caixa (contagem e fecho dos TPA)"
        >
          <Lock className="w-3.5 h-3.5" /> Fechar caixa
        </button>
      )}
      <span className="text-[11px] text-zinc-400 hidden md:inline" data-testid="pos-standalone-user">
        {user?.company_name ? `${user.name} · ${user.company_name}` : user?.name}
      </span>
      <div
        className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-orange-600 flex items-center justify-center text-xs font-bold text-white shadow"
        data-testid="pos-user-avatar"
        title={user?.name}
      >
        {(user?.name || "U").slice(0, 1).toUpperCase()}
      </div>
      <button
        onClick={onHome}
        className="w-8 h-8 rounded-md flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5"
        data-testid="close-pos-btn"
        title="Fechar POS"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  </header>
);
